import type { FunctionComponent } from 'react';

import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';

import styles from './livespins-frame.module.scss';

const style = createStyleHelper(styles, 'livespins-frame');

export interface ILivespinsProps {
    className?: string;
    launchUrl: string;
}

export const LivespinsFrame: FunctionComponent<ILivespinsProps> = ({ className, launchUrl }) => {
    return <iframe className={createClassName([className, style()])} src={launchUrl} />;
};
